import { render, staticRenderFns } from "./AddPause.vue?vue&type=template&id=76bd28a0&scoped=true&"
import script from "./AddPause.vue?vue&type=script&lang=js&"
export * from "./AddPause.vue?vue&type=script&lang=js&"
import style0 from "./AddPause.vue?vue&type=style&index=0&id=76bd28a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bd28a0",
  null
  
)

export default component.exports